export const LeadAgentLeadStageTypeId = {
  1: 'Referred',
  2: 'Viewed', // Previously "Accepted"
  3: 'Contacted',
  4: 'Appraised',
  5: 'Appointed',
  6: 'Listed',
  7: 'Undefined',
  8: 'Undefined',
  9: 'Shown to vendor',
  10: 'Shortlisted',
  11: 'Attempted',
};

export const LeadAgentLeadStageType = {
  Shown_To_Vendor: 9,
  Shortlisted: 10,
  Referred: 1,
  Viewed: 2,
  Contacted_Vendor: 3,
  Appraised: 4,
  Appointed: 5,
  Listed: 6,
  Undefined: 7,
  Attempted: 11,
};
